module.exports = __webpack_public_path__ + "img/intelligent-accounting.22601981.png";